module.exports = __webpack_public_path__ + "static/RemovePrice-8b0929a6f65e7269a86d02f07a65b717.png";